/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Swal_AfterInputs */

const en_merge_swal_after = /** @type {(inputs: Merge_Swal_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After`)
};

const fr_merge_swal_after = /** @type {(inputs: Merge_Swal_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apres`)
};

const de_merge_swal_after = /** @type {(inputs: Merge_Swal_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach`)
};

const it_merge_swal_after = /** @type {(inputs: Merge_Swal_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dopo`)
};

const ru_merge_swal_after = /** @type {(inputs: Merge_Swal_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`После`)
};

const es_merge_swal_after = /** @type {(inputs: Merge_Swal_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Después`)
};

const zh_cn2_merge_swal_after = /** @type {(inputs: Merge_Swal_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`后`)
};

const ja_merge_swal_after = /** @type {(inputs: Merge_Swal_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`後`)
};

const hi_merge_swal_after = /** @type {(inputs: Merge_Swal_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाद`)
};

const pt_pt2_merge_swal_after = /** @type {(inputs: Merge_Swal_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depois`)
};

/**
* | output |
* | --- |
* | "After" |
*
* @param {Merge_Swal_AfterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_swal_after = /** @type {((inputs?: Merge_Swal_AfterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Swal_AfterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_swal_after(inputs)
	if (locale === "de") return de_merge_swal_after(inputs)
	if (locale === "it") return it_merge_swal_after(inputs)
	if (locale === "ru") return ru_merge_swal_after(inputs)
	if (locale === "es") return es_merge_swal_after(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_swal_after(inputs)
	if (locale === "ja") return ja_merge_swal_after(inputs)
	if (locale === "hi") return hi_merge_swal_after(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_swal_after(inputs)
	return en_merge_swal_after(inputs)
});